import { IRealTimeTranscriptionConnection } from "./interfaces/IRealTimeTranscriptionConnection";
import { AugloopRealTimeTranscriptionConnection } from "./augloop/AugloopRealTimeTranscriptionConnection";

export function CreateDefaultRealTimeTranscriptionConnection(): IRealTimeTranscriptionConnection {
    return new AugloopRealTimeTranscriptionConnection();
};